import { types } from 'mobx-state-tree';
//import Currency from './Currency'

export default types.model('Customer', {
	Id: types.identifierNumber ,
	Name: types.string,
	Number: types.maybeNull(types.string),
	City: types.maybeNull(types.string),
	Role: types.string,
	CustomerType: types.string // organization|personal
	//Currencies: types.maybeNull(types.array(Currency))
}).views(self => ({
	
})).actions(self => ({
}));
